import styled from "styled-components";
import Navbar from "react-bootstrap/Navbar";
import {
  Dropdown,
  Button,
  Space,
  Breadcrumb,
  Modal,
  Badge,
  Input,
  Divider,
} from "antd";
import { DownOutlined, BellOutlined } from "@ant-design/icons";
import Container from "react-bootstrap/Container";

export const XHeaderContainer = styled(Container)`
  @media only screen and (max-width: 991.99px) {
    display: none;
  }
  background: ${({ theme }) => theme.settings.whiteColor} !important;
  border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
  padding: 10px 30px 10px 30px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
`;
export const XHeaderTopRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  .header-profile-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  @media only screen and (max-width: 991.99px) {
    ${({ $responsive }) =>
      $responsive &&
      `
        width: 100%;
        height: 36px;

        .header-profile-trigger {
          height: 36px;
          gap: 5px;
        }
      `}
  }
  .hideMob {
    @media only screen and (max-width: 991.99px) {
      display: none;
    }
  }
`;
export const XBadge = styled(Badge)`
  font-size: 10px;
  padding: 0px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  padding: 7px;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  @media only screen and (max-width: 991.99px) {
    margin-right: 10px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: ${({ theme }) => theme.settings.imgFilterColor} !important;
  }
  .ant-badge-count {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    background-color: ${({ theme }) => theme.settings.primary};
    @media only screen and (max-width: 991.99px) {
      background-color: transparent;
      color: ${({ theme }) => theme.settings.primary};
      border: 1px solid ${({ theme }) => theme.settings.primary};
      padding: 0px 3px;
      font-weight: 500;
    }
  }
`;
export const XDivider = styled(Divider)`
  @media only screen and (max-width: 991.99px) {
    display: none;
  }
`;
export const XDropdown = styled(Dropdown)`
  a {
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    text-decoration: none;
  }
`;
export const XDownOutlined = styled(DownOutlined)`
  color: ${({ theme }) => theme.settings.secondary};
  font-size: 10px;
  @media only screen and (max-width: 991.99px) {
    display: ${({ $responsive }) => ($responsive ? "inline-flex" : "none")};
    align-items: center;
    font-size: 9px;
  }
`;
